import {
  getBolDetails,
  getComplianceDetails,
  updateHSCode,
  getAllCitySearchData,
  updateCargoDestination,
  refreshBol,
  multipleBills,
  refreshBolFromGcss
} from "@/common/service/apiaggregator/apiAgreegatorService.js";

const removeDuplicateObject = data => {
  const portData = [];
  data.forEach(element => {
    let tempItem = { label: "", value: "", name: "" };
    tempItem.label = element.cityName;
    tempItem.value = element.countryName;
    tempItem.name = element.cityCode;
    portData.push(tempItem);
  });
  const filteredPortData = Array.from(portData.reduce((map, obj) => map.set(obj.name, obj), new Map()).values());
  const dataLoadCompPort = [];
  filteredPortData.forEach(element => {
    let item = { label: "", value: "", name: "" };
    item.label = element.label + "," + element.value;
    item.value = element.label + "," + element.value;
    item.name = element.name;
    dataLoadCompPort.push(item);
  });
  return dataLoadCompPort;
};

const getComplianceList = bolNumber => {
  return (state?.bolRecords?.shipments || [])
    .filter(shipmentItem => shipmentItem.shipmentNumber === bolNumber)
    .flatMap(shipmentItem =>
      (shipmentItem.route?.routeLinks || []).flatMap(routeItem =>
        (routeItem.compliances || []).map(compItem => ({
          complianceId: compItem?.complianceId,
          firstEventLinkedDate: compItem?.firstEventLinkedDate
        }))
      )
    )
    .filter(compItem => compItem.complianceId !== undefined && compItem.firstEventLinkedDate !== undefined);
};

const state = {
  resultsCache: {
    data: {},
    origin: ""
  },
  cargoDestinationList: [],
  multipleBillcheck: [],

  bolNumber: null,
  bolRecords: {},
  bolRecordsError: null,
  cargoDestinationListError: null,
  multipleBillcheckError: null,
  updateHSCodeError: null,
  updateHSCodeState: false,
  bolRecordsLoader: false,
  cargoDestinationListLoader: false,
  refreshBolLoader: false,
  isSearchedBolCancelled: false,
  isSplitFlag: false,
  ORRShipments: [],
  operationalShipment: [],

  enableBackButton: false,
  gcssRefreshBolStatus: "",
  refreshBolStatus: ""
};

const mutations = {
  addToResultCache(state, content) {
    if (content.type === "data" && content.data && content.origin) {
      state.resultsCache.data = content.data;
      state.resultsCache.origin = content.origin;
    }
  },
  setBolRecords(state, result) {
    state.bolRecords = result;
    //status possible values as per API: Approved | Cancelled | Not Found
    state.isSearchedBolCancelled =
      result && result.status && result.status.toLowerCase() === "cancelled" ? true : false;
  },
  setBol(state, bol) {
    state.bolNumber = bol;
  },
  setCargoDestinationList(state, value) {
    state.cargoDestinationList = value;
  },
  setMultipleBillcheck(state, value) {
    state.multipleBillcheck = value;
  },

  setRefreshBolStatus(state, value) {
    state.refreshBolStatus = value;
  },
  setGcssRefreshBolStatus(state, value) {
    state.gcssRefreshBolStatus = value;
  },

  setEnableBackButton(state, value) {
    state.enableBackButton = value;
  },
  setSplitFlagButton(state, value) {
    state.isSplitFlag = value;
  },
  setUpdateHSCodeState(state, value) {
    state.updateHSCodeState = value;
  },
  setOpeartionalShipment(state, value) {
    if (state.operationalShipment.indexOf(value) === -1) {
      state.operationalShipment.push(value);
    }
  },
  resetOpeartionalShipment(state, value) {
    state.operationalShipment = value;
  },
  setORR(state, value) {
    if (state.ORRShipments.indexOf(value) === -1) {
      state.ORRShipments.push(value);
    }
  },
  resetORRShipment(state, value) {
    state.ORRShipments = value;
  },
  setErrorState(state, param) {
    state[`${param.type}Error`] = param.error
      ? "has Error" in param.error
        ? param.error
        : { hasError: true, status: param.error.status, message: param.error.message }
      : null;
  },
  setLoadingState(state, param) {
    state[`${param.type}Loader`] = param.value;
  }
};

const actions = {
  async fetchBolDetails({ commit, rootState }, bolNumber) {
    commit("setLoadingState", { type: "bolRecords", value: true });
    commit("setBolRecords", null);
    commit("setUpdateHSCodeState", false);
    commit("setSplitFlagButton", false);
    commit("resetORRShipment", []);
    commit("resetOpeartionalShipment", []);
    try {
      const complaincePromises = [];
      let rawData;

      let data = {};
      rawData = await getBolDetails(bolNumber, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setErrorState", {
          type: "bolRecords",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }
      /* Fetching complaince data for each item - Start */
      data.shipments.forEach(element => {
        if (element.isORR === true && (element.isSplit === false || element.isSplit === null || !element.isSplit)) {
          commit("setORR", element.shipmentNumber);
        } else if (element.isSplit === true) {
          commit("setSplitFlagButton", true);
        }

        element.route?.routeLinks.forEach(item => {
          if (item.compliances) {
            item.compliances.forEach((cid, index, complaince) => {
              complaincePromises.push(fetchComplaince(cid, data.bolNumber));
              Promise.all(complaincePromises).then(pdata => {
                for (const tempItem of pdata) {
                  if (complaince[index] === tempItem.complianceId) {
                    complaince[index] = tempItem;
                    if (tempItem.references && tempItem.references.length > 0) {
                      for (const refItem of tempItem.references) {
                        refItem.oldValue = refItem.value;
                      }
                    }
                  }
                }
              });
            });
          }
        });

        element.parties.forEach(pItem => {
          for (const cItem of rootState.commonStore.countryList) {
            if (
              pItem.customerInformation &&
              pItem.customerInformation.country &&
              cItem.name === pItem.customerInformation.country
            ) {
              pItem.countryName = cItem.value;
            }
          }
        });
      });
      /* Fetching complaince data for each item - End */
      if (data.cargoAndEquipments) {
        for (const cargoItem of data.cargoAndEquipments) {
          if (cargoItem && cargoItem.equipments) {
            for (const equipItem of cargoItem.equipments) {
              if (equipItem && equipItem.isBelongsToOperationalShipment === true) {
                commit("setOpeartionalShipment", equipItem.shipmentNumber);
              }
            }
          }
          if (cargoItem.cargos) {
            for (const item of cargoItem.cargos) {
              if (item.hsCode) {
                item.oldHSCode = item.hsCode;
              }
            }
          }
        }
      }

      Promise.allSettled(complaincePromises).then(() => {
        commit("setBolRecords", data);
        commit("setErrorState", { type: "bolRecords", error: "" });
        commit("setLoadingState", { type: "bolRecords", value: false });
      });
      if (state.bolNumber != bolNumber) {
        commit("setBol", bolNumber);
      }
    } catch (error) {
      commit("setBol", null);
      commit("setBolRecords", null);
      commit("setErrorState", { type: "bolRecords", error });
      commit("setLoadingState", { type: "bolRecords", value: false });
    }
  },
  async fetchCargoDestinationList({ commit }, searchText) {
    commit("setCargoDestinationList", []);
    commit("setLoadingState", { type: "cargoDestinationList", value: true });
    try {
      let rawData,
        data = [];

      rawData = await getAllCitySearchData(searchText, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setErrorState", {
          type: "cargoDestinationList",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }
      const cargoDestinationData = removeDuplicateObject(data);

      commit("setCargoDestinationList", cargoDestinationData);
      commit("setErrorState", { type: "cargoDestinationList", error: "" });
      commit("setLoadingState", { type: "cargoDestinationList", value: false });
    } catch (error) {
      commit("setCargoDestinationList", []);
      commit("setErrorState", { type: "cargoDestinationList", error });
      commit("setLoadingState", { type: "cargoDestinationList", value: false });
    }
  },
  async multiplebillsData({ commit }, bookingNumber) {
    commit("setMultipleBillcheck", []);
    commit("setLoadingState", { type: "multipleBillcheck", value: true });
    try {
      let rawData,
        data = [];

      rawData = await multipleBills(bookingNumber, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setErrorState", {
          type: "multipleBillcheck",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }
      //const multiData = removeDuplicateObject(data);

      commit("setMultipleBillcheck", data);
      commit("setErrorState", { type: "multipleBillcheck", error: "" });
      commit("setLoadingState", { type: "multipleBillcheck", value: false });
    } catch (error) {
      commit("setMultipleBillcheck", []);
      commit("setErrorState", { type: "multipleBillcheck", error });
      commit("setLoadingState", { type: "multipleBillcheck", value: false });
    }
  },

  async saveCargoDestination({ commit, dispatch, rootState }, params) {
    commit("setLoadingState", { type: "updateCargo", value: true });
    try {
      let rawData;
      const { bolNumber, cargoDestination } = params;
      const complianceWithLinkedDates = getComplianceList(state.bolNumber);
      const req_body = {
        bolNumber,
        cargoDestination,
        body: {
          complianceWithLinkedDates,
          userName: rootState.userAccount.loginDetails.name,
          userId: rootState.userAccount.loginDetails.idTokenClaims.MaerskID
        }
      };
      rawData = await updateCargoDestination(req_body, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setErrorState", {
          type: "updateCargo",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      }

      dispatch("fetchBolDetails", req_body.bolNumber);
      commit("setErrorState", { type: "updateCargo", error: "" });
      commit("setLoadingState", { type: "updateCargo", value: false });
    } catch (error) {
      commit("setErrorState", { type: "updateCargo", error });
      commit("setLoadingState", { type: "updateCargo", value: false });
    }
  },
  async refreshbolData({ commit, rootState }, params) {
    commit("setRefreshBolStatus", "");
    commit("setLoadingState", { type: "refreshBol", value: true });
    try {
      let rawData;
      const req_body = {
        bolNumbers: params.bolIdList,
        userName: rootState.userAccount.loginDetails.name,
        userId: rootState.userAccount.loginDetails.idTokenClaims.MaerskID,
        empty: rootState.bolDetails.bolRecords.empty || rootState.billOfLading.bolRecordsNew.empty,
        lcl: params.isLcl || false
      };
      rawData = await refreshBol(req_body, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setErrorState", {
          type: "refreshBol",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      }
      commit("setRefreshBolStatus", rawData.status);
      commit("setErrorState", { type: "refreshBol", error: "" });
      commit("setLoadingState", { type: "refreshBol", value: false });
    } catch (error) {
      commit("setRefreshBolStatus", "");
      commit("setErrorState", { type: "refreshBol", error });
      commit("setLoadingState", { type: "refreshBol", value: false });
    }
  },

  async refreshbolDataFromGcss({ commit }, params) {
    commit("setGcssRefreshBolStatus", "");
    commit("setLoadingState", { type: "refreshBol", value: true });
    try {
      let rawData;
      rawData = await refreshBolFromGcss(params, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setErrorState", {
          type: "refreshBol",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      }
      commit("setGcssRefreshBolStatus", rawData.status);
      commit("setErrorState", { type: "refreshBol", error: "" });
      commit("setLoadingState", { type: "refreshBol", value: false });
    } catch (error) {
      commit("setGcssRefreshBolStatus", "");
      commit("setErrorState", { type: "refreshBol", error });
      commit("setLoadingState", { type: "refreshBol", value: false });
    }
  },

  async updateHS6Code({ commit, dispatch, rootState }, cParams) {
    commit("setLoadingState", { type: "updateHSCode", value: true });
    commit("setUpdateHSCodeState", false);
    try {
      let rawData;

      const { hscode, hsOldcode, cargoSequence } = cParams;
      const complianceWithLinkedDates = getComplianceList(state.bolNumber);
      const req_params = {
        hscode,
        hsOldcode,
        cargoSequence,
        bolNumber: state.bolNumber,
        body: {
          complianceWithLinkedDates,
          userName: rootState.userAccount.loginDetails.name,
          userId: rootState.userAccount.loginDetails.idTokenClaims.MaerskID
        }
      };

      rawData = await updateHSCode(req_params, true);
      if (rawData.status > 200 && rawData.status <= 499) {
        commit("setErrorState", {
          type: "updateHSCode",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
        commit("setUpdateHSCodeState", true);
      }

      dispatch("fetchBolDetails", state.bolNumber);
      commit("setErrorState", { type: "updateHSCode", error: "" });
      commit("setLoadingState", { type: "updateHSCode", value: false });
    } catch (error) {
      commit("setUpdateHSCodeState", true);
      commit("setErrorState", { type: "updateHSCode", error });
      commit("setLoadingState", { type: "updateHSCode", value: false });
    }
  },
  resetBOLrecords({ commit }) {
    commit("setBolRecords", null);
    commit("setBol", null);
  }
};

async function fetchComplaince(complianceId, bolNumber) {
  let response = { isEmpty: true, complianceId };
  try {
    response = await getComplianceDetails(complianceId, bolNumber, false);
    return response;
  } catch (e) {
    return response;
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
